// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2SlBq","emails":"CreateEditClinics_emails__3sucn","emailTagLabel":"CreateEditClinics_emailTagLabel__3r3u7"};